import React, { createContext, useCallback, useEffect, useRef, useState } from 'react'
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit'
import { RunVisualUnitWithId_VisualUnit } from '../../Interfaces/APIContracts/RunVisualUnitWithId_VisualUnit'
import {
    IVUconfigResponse,
    useSubmitFormMutation,
    useExecuteTableMutation,
    useExecuteChartMutation,
    useMarkVUFavouriteMutation,
} from '../../Redux/VisualUnits/visualUnitAPISlice'

import {
    ChartAxes,
    chartFilterValue,
    ChartSettings,
    getReportActionsState,
    getVUParamsInfoState,
    IVuSettings,
    SetVudata,
} from '../../Redux/VisualUnits/visualUnitStateSlice'
import { FoundationsConstants } from '../../FoundationsConstants'
import { FoundationsEnums } from '../../enum'
import { getCurrentUserData, RootState } from '../../Redux/store'
import {
    getDrillThruPayload,
    IDrillThruPayloadState,
    setDrillThruState,
} from '../../Redux/DrillThru/DrillThruSlice'
import { useDispatch, useSelector } from 'react-redux'
import {
    findDrillThruDataPoint,
    initialChartPayload,
    initialTablePayload,
    isActivePanel,
    isChart,
    isSummary,
    isTable,
} from '../../VisualunitHelpers'
import { getWorkspaceData } from '../../Redux/Workspace/workspaceSlice'
import DrillThru from '../DrillThru/DrillThru'
import DashboardVUParams from './DashboardVuParams'
import { VuSettings } from './VuSettings'
import { markVisualUnitFavorite } from '../../Pages/Workspace/workspace'
import ReportInfo from './ReportInfo'
import ReportEl from './Report'
import { VisualUnitApiDTO_VisualUnit_Extended } from '../../Interfaces/VisualUnit/VisualUnitApiDTO_VisualUnit'
import { RunVisualUnitWithId_VisualUnit_Extended } from '../../Interfaces/VisualUnit/RunVisualUnitWithId_VisualUnit'
import { VUSettingsDialog } from './VUSettingsDialog'
import { useCheckEditSaveMutation } from '../../Redux/ReportActions/reportActionsSlice'

import { createZustandScopedVisualUnitStore } from '../../Redux/zustand_VisualUnitStore'
import { useZustandVisualUnitStore, Zustand_VisualUnitProvider } from './vuContext'
import { useWorkspaceStore } from '../../Pages/Workspace/workspaceContext'
import { WorkspaceApiDTO_Workspace } from '../../Interfaces/APIContracts/WorkspaceApiDTO_Workspace'

declare let window: any
const UnicornApp = window.unicornInstance as any

export interface ChartPayload {
    visualUnitId: number
    tempVisualUnitId: number
    isAsync?: boolean
    viewerType: number
    callerType: string
    forceRefresh: number
    privacyLock: number
    tableSettings?: IVuSettings | undefined
    BuildQuery?: any
    SnapshotCount?: number //resolving conflicts; adding optional.
    isAutoRefreshCall?: boolean
    chartSettings: ChartSettings | undefined
    chartSwitch: ChartAxes | undefined
    chartFilter: chartFilterValue[]
    viewerTypeChanged: boolean
    Is3DView: boolean
}

export interface TablePayload {
    callerType: string
    dashBoardId: number
    visualUnitId: number
    tempVisualUnitId: number
    grandTotal: boolean
    pageSize: number
    pageNumber: number
    sortColumn: string
    sortOrder: string
    privacyLock: number
    viewerTypeChanged: boolean
    tableSettings?: { [s: string]: any }
    viewerType: number
    forceRefresh: number
    EngineType: string
    isAsync?: boolean
    BuildQuery?: any
    isAutoRefreshCall?: boolean
}
export interface ITableDrillThru {
    initialPayload: any
    actionMode: string
    hasError: boolean
    modelData: any
    inline: boolean
    isAutoRefresh: boolean
    measureIndex: number
    isDrillThruAllowed: boolean
    measureVal: any
    dataExplore: any
    autoRefreshInterval: number
    data_is_summary: boolean
    inlineParentNode: any
    ishelprequest: boolean
    vuDataObj: any
    engineType: string
    __this: any
    ViewerType: any
}

export interface chartFilter {
    displayValue: string
    displayValueList: string[]
    rawValue: string
    rawValueList: string[]
    filterVUDetail: { [s: string]: any }
}

// TODO: Base workspace code that creates report list on renderHomePage from FoundationsHome

// TODO: one execute make reducer call and udpate report for the visual unit frame
// TODO 2: remove any state that is duplicated in report
export const ReportFrame = (props: {
    setVuData : (data:VisualUnitApiDTO_VisualUnit_Extended)=>void
    report: VisualUnitApiDTO_VisualUnit_Extended
    dashboardId: number
    wsid: string
    collapsed: boolean
    actionType: string
    setremoveFromWorkspace : ({ flag, id }: { flag: boolean; id: number }) => void;                                                                           
    updateAllTableVUsOrSpecific: (key: keyof VisualUnitApiDTO_VisualUnit_Extended, value: any, limit?: number,VuId?:number) => void

}) => {
    const { dashboardId, wsid, actionType,setVuData,updateAllTableVUsOrSpecific,setremoveFromWorkspace } = props //TODO create reducer for managing report state for updating view
    const [report, setReport] = useState<VisualUnitApiDTO_VisualUnit_Extended>(props.report)
    // TODO : dataExplore is toggled with params and set tempViewerType to viewerType
    const [dataExplore, setDataExplore] = useState(false)
    const [instrumentation, setInstrumentation] = useState('')
    const [engineType, setEngineType] = useState('newengine')
    const [cellInfo, setCellInfo] = useState({} as { [s: string]: any })
    const [cellValue, setCellValue] = useState('')
    const [iseditSettingsDialogOpen, setiseditSettingsDialogOpen] = useState(false)
    const [saveVUdataChanges, setsaveVUdataChanges] = useState<any>(false)
    const [shouldcallCheckeditsave, setshouldcallCheckeditsave] = useState<boolean>(false)
     const [CheckEditSaveResponse, setCheckEditSaveResponse] = useState<any>(null)
    const [usersUsingVUs, setusersUsingVUs] = useState(0)
    const [dashBoardsUsingVUs, setdashBoardsUsingVUs] = useState(0)
    const [roleNames, setRoleNames] = useState<string[]>([])

    // TODO : update everytime a refresh is made
    const [isCollapsed, setIsCollapsed] = useState<boolean>(props.collapsed)
    const isUpdateFromSettings = useRef(false);
    const isSaveClicked = useRef(true);
    const reportListRef = useRef<HTMLDivElement[]>([]);
    const drillThruDpListRef = useRef<any[]>([]);

    const setReportRef = useCallback((el: HTMLDivElement | null) => {
        if (el && !reportListRef.current.includes(el)) {
            reportListRef.current.push(el);
        }
    }, []);// FP-11689 Code for scrolling to the last report when addNewVU OR copyVU is clicked
    useEffect(() => {
        setIsCollapsed(props.collapsed)
    }, [props.collapsed])

    
    useEffect(() => {
        if ((actionType === 'addNewVU' || actionType === 'copyVU') && reportListRef.current.length > 0) {
            setIsExplore(true)
            const lastIndex = reportListRef.current.length - 1;
            const lastReportRef = reportListRef.current[lastIndex];

            if (lastReportRef) {
                lastReportRef.scrollIntoView({ behavior: "smooth", block: "center" });

                const timer = setTimeout(() => {}, 2000);
                return () => clearTimeout(timer);
            }
        } // FP-11689 Code for scrolling to the last report when addNewVU OR copyVU is clicked
    }, [actionType]);
    //ensure workspace and local copies of collapsed stay in sync
    const [isDrillThruLaunched, setIsDrillThruLaunched] = useState(false)
    // TODO : does executeresult need a default object or does it need to wait for execute call then render VU? (i.e. show skeleton loader until ready)
    const [executeResult, setExecuteResult] = useState<RunVisualUnitWithId_VisualUnit_Extended>(
        {} as RunVisualUnitWithId_VisualUnit_Extended
    )
    const [operationStatusMessage, setOperationStatusMessage] = useState('')
    const [reportFailed, setReportFailed] = useState(false)
    const [headerLoading, setHeaderLoading] = useState<boolean>(false)
    const [dataLoading, setDataLoading] = useState(!props.collapsed)
    const [redrawReport, setRedrawReport] = useState(false)
    // const [isRedrawVU, setIsRedrawVU] = useState(false);
    const [tempVuData, setTempVuData] = useState({
        ...props.report,
        TempVisualUnitId: -1,
    } as VisualUnitApiDTO_VisualUnit_Extended)
    const setupVU = useZustandVisualUnitStore((s) => s.setupVU);
    const zustand_vuState = useZustandVisualUnitStore((s) => s.vuState);

        // Initialize state
    useEffect(() => {
        setupVU(tempVuData);
    }, [tempVuData]);

    // Detect and send to server
    useEffect(() => {
        if (zustand_vuState) {
            setTempVuData(zustand_vuState)
        }
    }, [zustand_vuState]);

    const updateTempVuData = (key: keyof VisualUnitApiDTO_VisualUnit_Extended, value: any) => {        
        setTempVuData({ ...tempVuData, [key]: value })
    }
    // const [tempData, setTempData] = useState({
    //     tempChartSwitch: report.ChartSwitch,
    //     // All of these are either the current value of the report, or the last value set while editing
    //     tempChartSettings: report.ChartSettings,
    //     tempTableSettings: report.TableSettings,
    //     vuTempId: -1,
    //     tempViewerType: report.viewerType,
    //     buildQuery: false,
    //     applyChange: false,
    // } as TempReportData)
    // const updateTempData = (key: keyof TempReportData, value: any) => {
    //     setTempData({ ...tempData, [key]: value })
    // }

    const [isVisible, setIsVisible] = useState(true)
    const [tableJSOnData, setTableJSOnData] = useState({} as any)
    const firstRender = useRef(true)

    const [callVUConfigAPI] = useSubmitFormMutation()
    const [callExecuteTableAPI, {data: executeTableReducer}] = useExecuteTableMutation()
    const [callExecuteChartAPI] = useExecuteChartMutation()
    const [callMarkVUfavouriteAPI] = useMarkVUFavouriteMutation()

    const getWorkspaceIdFromStore = useSelector(getWorkspaceData)?.data.WorkspaceId
    const drillThruInitPayload: IDrillThruPayloadState = useSelector(getDrillThruPayload)
    const vuObjParamsFromStore = useSelector(getVUParamsInfoState)
    const [callcheckEditSaveAPI] = useCheckEditSaveMutation()
    
    // isEditOpen also means that the VU is in explore mode
    // const isExplore = useSelector(
    //     (state: RootState) => getReportActionsState(state)[report.VisualUnitId]?.isEditOpen
    // )
    const [isExplore, setIsExplore] = useState(false)
    // Data set when reprot configuration changes in dashboardVuParams
    // const runVuDataPayloadStore: ChartPayload | TablePayload = useSelector(getRunVuDataPayload)
    const [TableReportAutoRefreshInterval, setTableReportAutoRefreshInterval] = useState<number>()

    const currentWorkspaceData: WorkspaceApiDTO_Workspace = useWorkspaceStore((s) => s.workspaceState);
    const bulkUpdateVUs = useWorkspaceStore((s) => s.updateVisualUnits);
    
    const dispatch = useDispatch()

    const getInitDrillThruPayload = () => {
        const initialPayload = {
            vuId: -1,
            vuTempId: -1,
            isAsync: true,
            cellId: '',
            cellValue: '',
            cellValueseriesName: '',
            cellValuecategoryName: '',
            vudetails: null,
            pageSize: 10,
            pageNumber: 1,
            drillThruDP: {},
            isSummaryReport: false,
            drillThruSetId: 0,
            drillThruActionType: 'dt_paginate',
            drillThruSearchString: '',
            dashBoardId: 0,
        }

        initialPayload.drillThruDP = cellInfo
        initialPayload.vuId = report.VisualUnitId
        initialPayload.isSummaryReport = false
        initialPayload.cellId = cellInfo.cellId
        initialPayload.cellValue = cellValue
        initialPayload.dashBoardId = dashboardId

        return initialPayload
    }

    // ========================================== Auto Refresh Code ==========================================
    const intervalRef: any = useRef(null)
    const lastRefreshedRef = useRef(Date.now()); // Track last refresh time with ref
    const [lastRefreshed, setLastRefreshed] = useState<number>(0)
    const [lastRefreshedStatus, setLastRefreshedStatus] = useState<any>(null)
    const [intervalCount, setIntervalCount] = useState<number>(0)
    const displayTimeDifferenceForTable = (dateObj: any) => {
        let timeDifferenceInSeconds = Math.floor((Date.now() - dateObj) / 1000)
        if (timeDifferenceInSeconds < 60) {
            return 'Just now'
        } else if (timeDifferenceInSeconds < 3600) {
            return (
                Math.floor(timeDifferenceInSeconds / 60) +
                (timeDifferenceInSeconds / 60 > 1 ? ' mins' : ' min')
            )
        } else if (timeDifferenceInSeconds < 864000) {
            return (
                Math.floor(timeDifferenceInSeconds / 3600) +
                (timeDifferenceInSeconds / 3600 > 1 ? ' hrs' : ' hr')
            )
        } else {
            return (
                Math.floor(timeDifferenceInSeconds / 86400) +
                (timeDifferenceInSeconds / 86400 > 1 ? ' days' : ' day')
            )
        }
    }
    const updateLastRefreshedTimeForTable = (dateObj: any) => {
        const minutesDifference: string = displayTimeDifferenceForTable(dateObj)
        setLastRefreshedStatus(minutesDifference)
    }

    const setRefreshIntervalLabel = () => {
        const refreshInterval = report.RefreshInterval;

        if (refreshInterval !== 0) {
            if (intervalRef.current) clearInterval(intervalRef.current); // Clear any existing intervals

            // Set the initial status immediately
            lastRefreshedRef.current = Date.now();
            updateLastRefreshedTimeForTable(lastRefreshedRef.current);


            // Set up interval to update UI every minute and check if it’s time to refresh
            intervalRef.current = setInterval(() => {
                const timeSinceLastRefresh = Math.floor((Date.now() - lastRefreshedRef.current) / 1000);

                if (timeSinceLastRefresh >= refreshInterval * 60) {
                    autorefreshVisualUnit();
                    lastRefreshedRef.current = Date.now(); // Directly update ref value
                    updateLastRefreshedTimeForTable(lastRefreshedRef.current);
                } else {
                    updateLastRefreshedTimeForTable(lastRefreshedRef.current);
                }
            }, 60000); // Run every minute
        }
    }
    useEffect(() => {
        return () => {
            if (intervalRef.current !== undefined) {
                clearInterval(intervalRef.current);
            }
        };
    }, []); // Empty deps: only run cleanup on unmount

    // ========================================== End Auto Refresh Code ==========================================

   

    useEffect(() => {
        if (
            tempVuData.ViewerType !== undefined &&
            executeResult.viewerType !== tempVuData.ViewerType &&
            executeResult.viewerType !== undefined &&
            !isCollapsed
        ) {
            // toggleReportLoader(true, 'Header')
            const callerType = isExplore
                ? FoundationsConstants.enumVUCallerType.Explore
                : FoundationsConstants.enumVUCallerType.Default
            if (tempVuData.ViewerType == FoundationsEnums.VisualUnitViewerType.ActivePanel) {
                setHeaderLoading(false)
                setDataLoading(false)
            }
            else if (tempVuData.ViewerType === FoundationsEnums.VisualUnitViewerType.Table) {
                runVisualUnitTable(callerType, true, false)
            }
            // else if (executeResult.viewerType === FoundationsEnums.VisualUnitViewerType.Table) {
            //     runVisualUnitTable(callerType, true, false)
            // }
            // need to wait for API call for active panels and table reports 
            else if (
                tempVuData.ViewerType !== FoundationsEnums.VisualUnitViewerType.ActivePanel && executeResult.viewerType !== FoundationsEnums.VisualUnitViewerType.Table && !isSummary(tempVuData)
            ) {
                //When changing between chart types don't wait for api to redraw the chart
                updateExecuteResult('viewerType', tempVuData.ViewerType)
                setRedrawReport(!redrawReport)
                runVisualUnitChart(callerType, true, true)
            } else if (executeResult.viewerType === FoundationsEnums.VisualUnitViewerType.Table) {
                updateExecuteResult('viewerType', tempVuData.ViewerType)
                runVisualUnitChart(callerType, true, true)
            }
            
            let updatedVUList = currentWorkspaceData.VisualUnits.map(x => (x.VisualUnitId == tempVuData.VisualUnitId ? {...tempVuData} : {...x}));
            bulkUpdateVUs(updatedVUList)
            

            if (!tempVuData.ViewerType) {
                console.error('Viewer type not found for current report')
            }
        }
    }, [tempVuData.ViewerType])

    // we should add a check for isExplore in this effect to avoid extra calls, 
    // but that will currently cause issues with updating the UI to match report setting changes. 
    // Need to revisit this to find a better way to handle both issues - Steven
    useEffect(() => {
        if (!isCollapsed){
            let runExecuteTable = isTable(tempVuData.ViewerType) || isSummary(tempVuData) ||
            isActivePanel(tempVuData.ViewerType) || tempVuData.XAxisList?.length > 0 || tempVuData.YAxisList?.length > 0
            //FP-12437 runExecuteTable added case for SVU (SVU in Add report)

            // This function is not handling updating the view type properly. 
            // View type updates must happen through state, not direct manipulation which can cause unpredictable behaviors- Steven 
            // ViewerTypeChecked(tempVuData)

            if (tempVuData.ViewerType === FoundationsEnums.VisualUnitViewerType.ActivePanel) {
                setHeaderLoading(false)
                setDataLoading(false)
            } else if (isChart(tempVuData.ViewerType)) {
                runVisualUnitChart()
            }
            else if (runExecuteTable) {
                runVisualUnitTable()
            } else {
                setOperationStatusMessage('Error processing report view type')
            }
        }
    }, [tempVuData.XAxisList, tempVuData.YAxisList, tempVuData.MeasureList, tempVuData.FilterableList])

    useEffect(() => {
        if (isUpdateFromSettings.current) {
            if (isTable(tempVuData.ViewerType) || isActivePanel(tempVuData.ViewerType)) {
                runVisualUnitTable()
            } else if (isChart(tempVuData.ViewerType)) {
                runVisualUnitChart()
            }
            isUpdateFromSettings.current = false;
        }
    }, [tempVuData]); //FIXME: Need to add specific trigger key
    
    useEffect(() => {
        if (tempVuData.TableSettings?.ApplySettings || tempVuData.ChartSettings?.ApplySettings) {
            const callerType = isExplore
                ? FoundationsConstants.enumVUCallerType.Explore
                : FoundationsConstants.enumVUCallerType.Default
            if (isTable(executeResult.viewerType)) {
                runVisualUnitTable(callerType)
            } else {
                runVisualUnitChart(callerType)
            }
        }
    }, [tempVuData.ChartSettings, tempVuData.TableSettings])

    useEffect(() => {
        if (tempVuData.ChartSwitch?.ApplySwitchValues) { // FP-12081 removing !firstRender.current &&
            const callerType = isExplore
                ? FoundationsConstants.enumVUCallerType.Explore
                : FoundationsConstants.enumVUCallerType.Default
            if (isTable(executeResult.viewerType)) {
                // =========================================== TODO handle forceRefresh flag for all table payloads
                // =================================================================================
                runVisualUnitTable(callerType)
            } else {
                updateExecuteResult('chartSwitch', tempVuData.ChartSwitch)
                runVisualUnitChart(callerType)
            }
        }
    }, [tempVuData.ChartSwitch])


    useEffect(() => {
        if (tempVuData.ChartFilter?.length > 0) {
            const callerType = isExplore
                ? FoundationsConstants.enumVUCallerType.Explore
                : FoundationsConstants.enumVUCallerType.Default
            if (isTable(executeResult.viewerType)) {
                runVisualUnitTable(callerType)
            } else {
                runVisualUnitChart(callerType)
            }
        }
    }, [tempVuData.ChartFilter])

    useEffect(() => {
        setIsDrillThruLaunched(false)
        if (!isExplore) {
            // setTempVuData({
            //     ...report,
            //     TempVisualUnitId: -1,
            //     BuildQuery: false,
            //     DashBoardId: -1
            // })
            updateTempVuData('TempVisualUnitId', -1)
            updateTempVuData('BuildQuery', false)
            updateTempVuData('DashBoardId', -1)
        }
    }, [isExplore])

    useEffect(() => {
        if (executeResult.reportData !== '' && executeResult.reportData !== undefined) {
            setTableJSOnData(JSON.parse(executeResult.reportData)?.ComputedData)
        }
    }, [executeResult.reportData])

    

    const updateReport = (key: keyof VisualUnitApiDTO_VisualUnit, newValue: any) => {
        setReport({ ...report, [key]: newValue })
    }

    const updateExecuteResult = (key: keyof RunVisualUnitWithId_VisualUnit, newValue: any) => {
        setExecuteResult({ ...executeResult, [key]: newValue })
    }
    const toggleDialog = () =>
        {
            if(actionType === "addNewVU" || actionType === "copyVU") {
                setiseditSettingsDialogOpen(!iseditSettingsDialogOpen)
            }
            else {
                setshouldcallCheckeditsave(true)
            }

        } 
    const currentUserData = useSelector((state: RootState) => getCurrentUserData(state))

    const isAdmin = ['FoundationsSystemAdmin', 'SystemAdmin'].indexOf(currentUserData.type) > -1
    const chartComponent = useRef<HTMLElement>(null)
    const markFavourite = () => {
        markVisualUnitFavorite(
            dashboardId + '',
            report.VisualUnitId,
            props.report.Name,
            report.AddedToFavourite,
            callMarkVUfavouriteAPI as any
        )
        updateTempVuData('AddedToFavourite', !report.AddedToFavourite)
        updateReport('AddedToFavourite', !report.AddedToFavourite)
    }

    const doExpColVisualUnit = (isCollapsed: boolean) => {
        const vuConfigData = {
            vuId: report.VisualUnitId,
            Expanded: !isCollapsed,
        }
        setDataLoading(!isCollapsed?true:false)
        setIsDrillThruLaunched(false)
        callVUConfigAPI(vuConfigData)
            .unwrap()
            .then((response: IVUconfigResponse) => {
                if (response != null) {
                    const resultData = response.data
                    if (resultData != null) {
                        if (response.statusCode == 200) {
                            setIsCollapsed(isCollapsed)
                            updateAllTableVUsOrSpecific('Collapsed', isCollapsed, undefined, tempVuData.VisualUnitId)
                            if (!isCollapsed) {
                                //VU is expanded
                                 const updatedViewerType = (tempVuData.ViewerType == FoundationsEnums.VisualUnitViewerType.SVU &&
                                                           (tempVuData.XAxisList.length != 0 || tempVuData.YAxisList.length != 0))
                                                           ? FoundationsEnums.VisualUnitViewerType.Table
                                                           : tempVuData.ViewerType
                                                          
                                const viewerType = updatedViewerType
                                    ? updatedViewerType
                                    : executeResult.viewerType

                                if (isActivePanel(viewerType)) {
                                    setDataLoading(false)
                                    setHeaderLoading(false)
                                } else {
                                    if (isTable(viewerType)) {
                                        runVisualUnitTable()
                                    } else if (isChart(viewerType)) {
                                        runVisualUnitChart()
                                    } 
                                    //TODO: FP-11694 - Expand/collapse need not convert anything to summary. 
                                    // else { 
                                    //     setConvertedToSummary(true)
                                    // }
                                }
                            } else {
                                // TODO close visualunitparams
                                //setDataLoading(true)  //Can someone please confirm why this is needed here? 
                                setHeaderLoading(false)
                                setDataLoading(false)
                                setExecuteResult({} as RunVisualUnitWithId_VisualUnit_Extended)
                            }
                        }
                    }
                }
            })
            .catch((err) => {
                console.error('error from  VU_config api..', err)
            })
    }

    const [drillThruLoading, setDrillThruLoading] = useState(false);

    const openDrillThru = useCallback(
        (cellInfo: any, cell: string) => {
            setCellInfo(cellInfo)
            setCellValue(cell)
            // setIsDrillThruLaunched(true)
            setHeaderLoading(true)
            setDrillThruLoading(true)
            let initPaylod: IDrillThruPayloadState = { ...drillThruInitPayload }
            initPaylod.drillThruDP = cellInfo
            initPaylod.vuId = report.VisualUnitId
            initPaylod.isSummaryReport = false
            initPaylod.cellId = cellInfo.cellId
            initPaylod.cellValue = cell
            initPaylod.dashBoardId = getWorkspaceIdFromStore
        },
        [drillThruInitPayload, getWorkspaceIdFromStore]
    )
    const handleDrillThruLoaded = () => {
        setDrillThruLoading(false); // Hide table only when DrillThru is fully ready
        setIsDrillThruLaunched(true)
        setHeaderLoading(false)
    };

    const closeDrillThru = () => {
        setIsDrillThruLaunched(false)
    }

    useEffect(() => {
        if (isCollapsed) {             // FP-11879 Closing the DrillThru when the report is collapsed
            closeDrillThru()
        }
    },[isCollapsed])

    const displayTotalTime = (
        isSingleVU: boolean,
        resultData: RunVisualUnitWithId_VisualUnit_Extended,
        startTime: number,
        ajaxTime: number,
        endTime: number
    ) => {
        if (!isSingleVU) {
            var inst = []
            inst.push("<span className='float-left instrumentation'>")
            inst.push(ajaxTime - startTime)
            inst.push(' ms; ')
            inst.push(endTime - ajaxTime)
            inst.push(' ms; ')
            if (resultData != undefined) {
                inst.push(resultData.DbTimeInMillisecs)
                inst.push(' ms; ')
                inst.push(' / ' + resultData.status.ServerTimeinMillsecs)
            }
            inst.push('</span>')
            return inst.join('')
        } else {
            return ''
        }
    }

    // TODO : handle report loading states
    const runVisualUnitTable = (
        callerType: string = FoundationsConstants.enumVUCallerType.Default,
        viewerTypeChanged: boolean = false,
        silent: boolean = false,
        forceRefresh: number = 0,
        engineType: string = 'newengine',
        isAutoRefreshCall: boolean = false
    ) => {
        const startTime = new Date().getTime()

        // Build the request object
        const reqRunVUData = initialTablePayload(
            report.VisualUnitId,
            dashboardId,
            forceRefresh,
            engineType
        )
        reqRunVUData.tempVisualUnitId = tempVuData.TempVisualUnitId
        reqRunVUData.pageSize = 10000
        reqRunVUData.viewerTypeChanged = viewerTypeChanged
        reqRunVUData.viewerType = FoundationsEnums.VisualUnitViewerType.Table
        reqRunVUData.tableSettings = tempVuData.TableSettings
        reqRunVUData.EngineType = engineType
        reqRunVUData.privacyLock = tempVuData.PrivacyLock
        reqRunVUData.forceRefresh =
            callerType == FoundationsConstants.enumVUCallerType.Refresh ? 1 : forceRefresh
        if (tempVuData.BuildQuery !== undefined) {
            ; (reqRunVUData as any).BuildQuery = tempVuData.BuildQuery
        }

        // TODO!! remove callback here. Then do same thing in runvisual unit chart
        // ie. create payload based on report/execute state
        callExecuteTableAPI(reqRunVUData)
            .unwrap()
            .then((response: IVUconfigResponse) => {
                if (response !== null) {
                    const ajaxEndTime = new Date().getTime()
                    if (!isAutoRefreshCall) {
                        dispatch(
                            setDrillThruState({
                                vuId: report.VisualUnitId,
                                isDrillThruOpen: false,
                            })
                        )
                    }
                    if (!isAutoRefreshCall) {
                        dispatch(
                            setDrillThruState({
                                vuId: report.VisualUnitId,
                                isDrillThruOpen: false,
                            })
                        )
                    }
                    let resultData = response.data
                    setIntervalCount(resultData?.vuDetails?.RefreshInterval)
                    if (resultData?.vuDetails?.RefreshInterval > 0) {
                        setRefreshIntervalLabel()
                    }
                    else{
                            clearInterval(intervalRef.current);
                    }
                    if (
                        response.statusCode == 200 &&
                        resultData !== null &&
                        resultData.status.OperationResult.Message === '' &&
                        resultData.displayMessage === '' &&
                        resultData.reportData //Some times report data comes as null not just empty, checking for truthiness in next else if
                    ) {
                        drillThruDpListRef.current = resultData.drillThruDPList
                        updateLastRefreshedTimeForTable(Date.now())
                        setLastRefreshed(Date.now())
                        setExecuteResult(resultData)
                        setOperationStatusMessage('')
                        updateTempVuData('TableSettings', resultData.tableSettings) //need this up-to date table settiings.
                        updateTempVuData('AllowDrillThru',resultData.vuDetails.AllowDrillThru)
                        updateTempVuData('Name',resultData.vuDetails.Name)
                        updateTempVuData('PrivacyLock',resultData.vuDetails.PrivacyLock)
                        if (!isExplore) {
                            const newVuDetails = {
                                ...resultData.vuDetails,
                                ViewerType: resultData.viewerType,
                            }
                            setReport(newVuDetails)
                            setVuData(resultData?.vuDetails)
                            if ((resultData?.vuDetails?.ViewerType == FoundationsEnums.VisualUnitViewerType.SVU ||
                                resultData?.vuDetails?.ViewerType == FoundationsEnums.VisualUnitViewerType.WorkList ||
                                resultData?.vuDetails?.ViewerType == FoundationsEnums.VisualUnitViewerType.WorkListWithoutGauge) &&
                                ( resultData?.vuDetails?.XAxisList.length == 0 &&  resultData?.vuDetails?.YAxisList.length == 0))
                                {
                                    //FP-11694: Type change detected. Lets rerender Workspace....
                                    let updatedVUList = currentWorkspaceData.VisualUnits.map(x => (x.VisualUnitId == tempVuData.VisualUnitId ? {...tempVuData} : {...x}));
                                    bulkUpdateVUs(updatedVUList)
                                }                            }
                           


                        setTableJSOnData(
                            resultData.reportData !== undefined && resultData.reportData !== ''
                                ? JSON.parse(resultData.reportData)?.ComputedData
                                : { Content: [], Headers: [] }
                        )

                        setInstrumentation(
                            displayTotalTime(
                                false,
                                resultData,
                                startTime,
                                ajaxEndTime,
                                new Date().getTime()
                            )
                        )
                        setReportFailed(false)
                    } else {
                        setReportFailed(true)                        
                        updateTempVuData('Name', resultData?.vuDetails.Name)
                        updateTempVuData('PrivacyLock', tempVuData.PrivacyLock)
                        updateReport('PrivacyLock', tempVuData.PrivacyLock)
                        if (resultData.status.OperationResult.Message !== '') {
                            if (resultData.IsEditAllowed == true) {
                                setReportFailed(false)
                            } else {
                                //FIXME: add data_explore check
                                setReportFailed(true)
                            }
                            setOperationStatusMessage(resultData.status.OperationResult.Message)
                        } else if (
                            currentUserData.userTypeNum == FoundationsEnums.UserType.SystemAdmin &&
                            resultData.displayMessage
                        ) {
                            // let option = {
                            //     width: window.oldUI ? '960px' : '100%',
                            //     position: "center",
                            //     height: 'auto',
                            //     dialogClass: "max-width-1300",
                            //     modal: true,
                            //     fluId: true,
                            //     resizable: false
                            // };
                            //FIXME: some dialog is there
                            setOperationStatusMessage(resultData.displayMessage)
                        }
                        else if (resultData.reportData === "") {
                            setOperationStatusMessage("No data found.")
                        }
                        else {
                            if (resultData.IsEditAllowed == false) {
                                //add data_explore check
                                setOperationStatusMessage(
                                    'Sorry, displaying data failed! Please check the report configuration. Add appropriate filters or organizers for the selected measure.'
                                )
                            } else {
                                setOperationStatusMessage('Sorry, displaying data failed.')
                            }
                        }
                    }
                }
                if (!silent) setRedrawReport(!redrawReport)
                setDataLoading(false)
                setHeaderLoading(false)
            })
            .catch((err) => {
                setHeaderLoading(false)
                setDataLoading(false)
                console.error('Execute table api failure.')
            })
        //******///
    }

    // TODO after execute call succeeds update report with new info
    const runVisualUnitChart = (
        callerType: string = FoundationsConstants.enumVUCallerType.Default,
        viewerTypeChanged: boolean = false,
        silent: boolean = false,
        forceRefresh: number = 0,
        engineType: string = 'newengine',
        isAutoRefreshCall: boolean = false
        // additionalVUData: any = null
    ) => {
        // let engineType_div = 'yes'
        // if (engineType === '' || engineType === undefined) {
        //     engineType =
        //         (!engineType_div || engineType_div.toLowerCase()) == 'no'
        //             ? 'oldengine'
        //             : 'newengine'
        // }
        const startTime = new Date().getTime()

        // let oldviewerType: any =
        //     vuTempId != -1 ? VUdataObj.data_tempViewerType : VUdataObj.data_viewerType
        // if (
        //     (oldviewerType != undefined && oldviewerType != viewerType) ||
        //     oldviewerType == undefined ||
        //     vuTempId != -1
        // ) {
        //     viewerTypeChanged = true
        // }

        // Build the request object
        const viewerType = tempVuData.ViewerType

        const reqRunVUChart = initialChartPayload(
            report.VisualUnitId,
            viewerType,
            dashboardId,
            forceRefresh,
            engineType
        )

        // TODO handle tempChartSwitch vs normal chartswitch
        reqRunVUChart.callerType = callerType
        reqRunVUChart.tempVisualUnitId = tempVuData.TempVisualUnitId
        reqRunVUChart.chartSettings = tempVuData.ChartSettings
        reqRunVUChart.viewerTypeChanged = viewerTypeChanged
        reqRunVUChart.chartSwitch = tempVuData.ChartSwitch
        reqRunVUChart.forceRefresh =
            callerType == FoundationsConstants.enumVUCallerType.Refresh ? 1 : forceRefresh
        if (tempVuData.ChartFilter !== undefined && tempVuData.ChartFilter !== null)
            reqRunVUChart.chartFilter = tempVuData.ChartFilter
        if (tempVuData.BuildQuery !== undefined) {
            ; (reqRunVUChart as any).BuildQuery = tempVuData.BuildQuery
        }
        callExecuteChartAPI(reqRunVUChart)
            .unwrap()
            .then((response: IVUconfigResponse) => {
                if (response !== null) {
                    const ajaxEndTime = new Date().getTime()
                    if (!isAutoRefreshCall) {
                        // TODO these should not be passed through store. drillthru toggle can happen by direct inheritance
                        dispatch(
                            setDrillThruState({
                                vuId: report.VisualUnitId,
                                isDrillThruOpen: false,
                            })
                        )
                    }
                    let resultData = response.data
                    if (
                        response.statusCode == 200 &&
                        resultData !== null &&
                        resultData.status.OperationResult.Message === '' &&
                        resultData.displayMessage === ''
                    ) {

                        updateLastRefreshedTimeForTable(Date.now())
                        setLastRefreshed(Date.now())
                        setIntervalCount(resultData?.vuDetails?.RefreshInterval)
                        if(resultData?.vuDetails?.RefreshInterval > 0)
                        {
                            setRefreshIntervalLabel()
                        }
                            setExecuteResult(resultData)
                        setOperationStatusMessage('')
                        if (!isExplore) {
                            const newVuDetails = {
                                ...resultData.vuDetails,
                                ViewerType: resultData.viewerType,
                                ChartSwitch: resultData.chartSwitch,
                                ChartSettings: resultData.chartSettings,
                                TableSettings: resultData.tableSettings,
                            }
                            setReport(newVuDetails)
                            setVuData(resultData?.vuDetails)
                            if( (resultData?.vuDetails?.ViewerType == FoundationsEnums.VisualUnitViewerType.SVU ||
                                resultData?.vuDetails?.ViewerType == FoundationsEnums.VisualUnitViewerType.WorkList ||
                                resultData?.vuDetails?.ViewerType == FoundationsEnums.VisualUnitViewerType.WorkListWithoutGauge) &&
                                (resultData?.vuDetails?.XAxisList.length == 0 && resultData?.vuDetails?.YAxisList.length == 0))
                                {
                                    //FP-11694: Type change detected, lets re-render workspace API...
                                    let updatedVUList = currentWorkspaceData.VisualUnits.map(x => (x.VisualUnitId == tempVuData.VisualUnitId ? {...tempVuData} : {...x}));
                                    bulkUpdateVUs(updatedVUList)
                                }
                        }

                        setInstrumentation(
                            displayTotalTime(
                                false,
                                resultData,
                                startTime,
                                ajaxEndTime,
                                new Date().getTime()
                            )
                        )
                        setReportFailed(false)
                    } else {
                        if (resultData.status.OperationResult.Message !== '') {
                            if (resultData.IsEditAllowed == true) {
                                setReportFailed(false)
                            } else {
                                //FIXME: add data_explore check
                                setReportFailed(true)
                            }
                            setOperationStatusMessage(resultData.status.OperationResult.Message)
                        } else if (
                            currentUserData.type == 'SystemAdmin' &&
                            resultData.displayMessage
                        ) {
                            //FIXME: some dialog is there
                            setOperationStatusMessage(resultData.displayMessage)
                        } else {
                            if (resultData.IsEditAllowed == false) {
                                //add data_explore check
                                setOperationStatusMessage(
                                    'Sorry, displaying data failed! Please check the report configuration. Add appropriate filters or organizers for the selected measure.'
                                )
                                setReportFailed(true)
                            } else {
                                setOperationStatusMessage('Sorry, displaying chart failed..')
                            }
                        }
                    }
                }
                if (!silent) setRedrawReport(!redrawReport)
                setHeaderLoading(false)
                setDataLoading(false)
            })
            .catch((err) => {
                setHeaderLoading(false)
                setDataLoading(false)
                console.error('execute chart api failure')
                console.error(err)
            })
    }

    const refreshVisualUnit = () => {
        // toggleReportLoader(true, 'Header')
        setHeaderLoading(true)
        let engineType = 'newengine'
        let viewerType = tempVuData.ViewerType
        const callerType = isExplore
            ? FoundationsConstants.enumVUCallerType.Explore
            : FoundationsConstants.enumVUCallerType.Refresh
        if (engineType) {
            // setVUdataObj((prev: any) => ({ ...prev, engineType: engineType }))
        }
        if (!viewerType) {
            viewerType = FoundationsEnums.VisualUnitViewerType.Table
        }
        if (isActivePanel(viewerType)) {
            console.error('Refresh for Active Panel visual units not implemented')
        } else if (isTable(viewerType)) {
            runVisualUnitTable(callerType, false, false, 1)
        } else if (isChart(viewerType)) {
            runVisualUnitChart(callerType, false, false, 1)
        } else {
            //FP-11694: Type change detected, so lets re-render workspace
            let updatedVUList = currentWorkspaceData.VisualUnits.map(x => (x.VisualUnitId == tempVuData.VisualUnitId ? {...tempVuData} : {...x}));
            bulkUpdateVUs(updatedVUList)
        }
    }

    const autorefreshVisualUnit = () => {
        console.log('autorefreshVisualUnit called'); // Please keep this console to observe API behavior on master for some time. 
        let viewerType = tempVuData.ViewerType
        if (!viewerType) {
            viewerType = FoundationsEnums.VisualUnitViewerType.Table
        }

        if (!isCollapsed)
            if (viewerType === FoundationsEnums.VisualUnitViewerType.ActivePanel) {
            } else {
                if (isActivePanel(viewerType)) {
                    console.error('Refresh for Active Panel visual units not implemented')
                } else if (isTable(viewerType)) {
                    runVisualUnitTable(FoundationsConstants.enumVUCallerType.AutoRefresh)
                } else {
                    runVisualUnitChart(FoundationsConstants.enumVUCallerType.AutoRefresh)
                }
            }
    }

    return (
        <div
            id={'vus_' + report.VisualUnitId}
            style={{ clear: 'both', display: isVisible ? 'block' : 'none', opacity: dataLoading ? '0.6' : '1' }}
        >
            <span id={'table_vus_' + report.VisualUnitId} className="vu-container ">
                <li id={'dashboard_vu_' + report.VisualUnitId} className="dashboard-vu-wrapper">
                    {/* REPORT HEADER - conditional based on app guid/not app guid*/}
                    <ReportInfo
                        report={report}
                        setReport={setReport}
                        tempVuData={tempVuData}
                        isAdmin={isAdmin}
                        sqlString={executeResult.sqlString}
                        isCollapsed={isCollapsed}
                        doExpColVisualUnit={doExpColVisualUnit}
                        isExplore={isExplore}
                        toggleIsExplore={() => setIsExplore(!isExplore)}
                        LastRefreshedTime={lastRefreshedStatus}
                        dashboardId={dashboardId}
                        isLoading={headerLoading}
                        snapShotCount={executeResult.SnapshotCount}
                        markFavourite={markFavourite}
                        setiseditSettingsDialogOpen={setiseditSettingsDialogOpen}
                        operationStatusMessage={operationStatusMessage}
                        refreshVisualUnit={refreshVisualUnit}
                        isDrillThruLaunched={isDrillThruLaunched}
                        onVisibilityChange={setIsVisible}
                        actionType={actionType}
                        tableJSOnData={tableJSOnData}
                        intervalCount={intervalCount}
                        executeResult={executeResult}
                        setremoveFromWorkspace={setremoveFromWorkspace}

                    />
                    {/* Dialog component */}
                            <VuSettings
                                isExplore={isExplore}
                                setisExplore={setIsExplore}
                                report={report}
                                setReport={setReport}
                                iseditSettingsDialogOpen={iseditSettingsDialogOpen}
                                setiseditSettingsDialogOpen={setiseditSettingsDialogOpen}
                                workspaceId={dashboardId}
                                drillThruDPList={executeResult.drillThruDPList}
                                vuParams={vuObjParamsFromStore}
                                // setIsRedrawVU={setIsRedrawVU}
                                setTempVuData={setTempVuData}
                                isUpdateFromSettings={isUpdateFromSettings}
                                isSaveClicked={isSaveClicked}
                                actionType={actionType}
                                saveVUdataChanges={saveVUdataChanges}
                                setsaveVUdataChanges={setsaveVUdataChanges}
                                shouldcallCheckeditsave={shouldcallCheckeditsave}
                                setupVU={setupVU}
                            />
                       
                    {/* END REPORT HEADER */}
                    {/* PARAMS REPORT HEADER? */}
                    {/* TODO : report params including showvisualunitparams function*/}
                    {/* REPORT PARAMS - hidden by default*/}
                    <div ref={setReportRef}>
                        {isExplore && (
                            <div className="dashboard-vu-params">
                                <DashboardVUParams
                                    tempVuData={tempVuData}
                                    setTempVuData={setTempVuData}
                                    dashboardId={dashboardId}
                                    setIsExplore={setIsExplore}
                                    onEditSave={toggleDialog}
                                    operationMode={actionType}
                                    onVisibilityChange={setIsVisible}
                                    refreshVisualUnit={refreshVisualUnit}
                                    operationStatusMessage={operationStatusMessage}
                                    setOperationStatusMessage={setOperationStatusMessage}
                                //setDialogClose = {setiseditSettingsDialogOpen}
                                />
                            </div>
                        )}
                    </div>
                    {/* END REPORT PARAMS */}
                    {/* DASHBOARD VU Search -> for APPGUID style VUS */}
                    <div
                        id={'dashboard_vu_search_' + report.VisualUnitId}
                        className="dashboard-vu-search hide"
                    ></div>
                    {/* END DASHBOARD VU SEARCH */}
                    {/* DRILLTHRU -hidden or not rendered by default?*/}
                    {/* TODO: for active panel lists have drillthru always open (no close option) */}

                    {!isCollapsed && (drillThruLoading || isDrillThruLaunched) ? (
                        <DrillThru
                            initialPayload={getInitDrillThruPayload()}
                            closeDrillThru={closeDrillThru}
                            reportData={{ id: report.VisualUnitId }}
                            inline={true}
                            dataExplore={dataExplore}
                            autoRefreshInterval={report.RefreshInterval}
                            data_is_summary={false}
                            engineType={engineType}
                            ViewerType={executeResult.viewerType}
                            executeResultData={executeResult}
                            dashBoardId={dashboardId}
                            isEnabledAutoNavigation={report.IsEnabledAutoNavigation}
                            onDrillThruLoaded={handleDrillThruLoaded}
                        />
                    ) : (
                        ''
                    )}                       
                    {/* END DRILLTHRU */}
                    {/* REPORT */}

                    {dataLoading ? (
                        <div
                            className="dashboard-vu-data"
                            style={{ opacity: 1 }}
                            id={`dashboard_vu_data_${report.VisualUnitId}`}
                        >
                            <div
                                id={`ajax-loading-box-${report.VisualUnitId}`}
                                className="ajax-loading-box"
                            >
                                <span className="ajax-loading-image">Loading...</span>
                            </div>
                        </div>
                    ) :
                    (executeResult.chartData ||
                        executeResult.viewerType == FoundationsEnums.VisualUnitViewerType.Table ||
                        tempVuData.ViewerType === FoundationsEnums.VisualUnitViewerType.ActivePanel ||
                        operationStatusMessage) && !isCollapsed ? (                           
                            <div
                                id={'dashboard_vu_data_' + tempVuData.VisualUnitId}
                                    className="dashboard-vu-data"
                                    style={{
                                        opacity: isDrillThruLaunched && !drillThruLoading ? '0' : '1',
                                        display: isDrillThruLaunched && !drillThruLoading ? 'none' : 'block',
                                    }}
                                >
                                    <ReportEl
                                        toggleIsExplore={() => setIsExplore(!isExplore)}
                                        chartComponent={chartComponent}
                                        executeResult={executeResult}
                                        openDrillThru={openDrillThru}
                                        isCollapsed={isCollapsed}
                                        tempVuData={tempVuData}
                                        reportFailed={reportFailed}
                                        redrawReport={redrawReport}
                                        tableJSOnData={tableJSOnData}
                                        setTableJSOnData={setTableJSOnData}
                                        operationStatusMessage={operationStatusMessage}
                                        isExplore={isExplore}
                                    />
                                </div>
                            ) : (                       
                            <></>
                        )}
                    {/* END REPORT */}
                    {instrumentation !== '' ? (
                        <span
                            className="float-left instrumentation"
                            dangerouslySetInnerHTML={{ __html: instrumentation }}
                        ></span>
                    ) : (
                        <></>
                    )}
                </li>
            </span>
        </div>
    )
}

export default ReportFrame
